import { supabase } from "@/lib/supabase";
import { isFullUrl } from "@/pages/seller/dashboard/types";

interface SmartImageProps {
  src: string;
  alt: string;
  className?: string;
}

const MEDIA_BUCKET = "covers";

/** Convierte una ruta interna o URL completa en una URL pública utilizable. */
function resolveImageUrl(src: string): string {
  if (!src) return "";
  if (isFullUrl(src)) return src;
  return supabase.storage.from(MEDIA_BUCKET).getPublicUrl(src).data.publicUrl;
}

export default function SmartImage({ src, alt, className }: SmartImageProps) {
  const resolved = resolveImageUrl(src);

  if (!resolved) {
    return <div className={`${className ?? ""} bg-background-200`}></div>;
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
}